export default __webpack_public_path__ + "static/media/Déferlantes - Logo2.9a8592dc.png";